export default __webpack_public_path__ + "static/media/image_house-price.0352d81a.svg";